export default "__VITE_ASSET__CTvVihnL__"